import { Component, OnChanges, Input } from '@angular/core';

import { Dimensions } from 'src/app/_charting/models/dimensions.type';
import { Scale } from '../../../models/scale.type';

@Component({
    selector: '[aaGridVer]',
    templateUrl: './grid-ver.component.html',
    styleUrls: [
        './grid-ver.component.scss'
    ],
    standalone: false
})
export class GridVerComponent implements OnChanges
{
    @Input() dimensions: Dimensions;
    @Input() scale: Scale;
    public ticks: number[] | Date[];

    ngOnChanges (): void
    {
        this.update();
    }

    update ()
    {
        if (!this.dimensions || !this.scale)
        {
            return;
        }

        const numberOfTicks = this.dimensions.boundedWidth < 600
            ? this.dimensions.boundedWidth / 100
            : this.dimensions.boundedWidth / 250;

        this.ticks = this.scale.ticks(numberOfTicks);
    }
}
